import React, { useEffect, useState } from "react";
import "./Examination.css";
import DynamicBanner from "../../include/DynamicBanner";
import api from "../../../../api";

const Examination = () => {
  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const normalizeImage = (img) => img || null;


  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        const res = await api.get("/api/sitepages/academic/examination");
        const d = res.data || {};

        if (cancelled) return;

        if (d?.banner_data?.images && Array.isArray(d.banner_data.images)) {
          d.banner_data.images = d.banner_data.images.map((img) => normalizeImage(img));
        }

        if (d?.page_content?.sections && Array.isArray(d.page_content.sections)) {
          d.page_content.sections = d.page_content.sections.map((section) => {
            const items = Array.isArray(section.items)
              ? section.items.map((it) => ({ ...it, image: it.image ? normalizeImage(it.image) : null }))
              : [];
            return { ...section, items };
          });
        }

        setData(d);
      } catch (err) {
        console.error("Error fetching Examination data:", err);
        setError(err);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loaded) return null;
  if (error) return null;
  if (!data || !data.page_content || !Array.isArray(data.page_content.sections)) return null;

  const banner = data?.banner_data
    ? {
      ...data.banner_data,
      images: data.banner_data.images?.map(img => `/${img.replace(/^\//, "")}`),
      mobileimage:data.banner_data.mobile_images?.map(img => `/${img.replace(/^\//, "")}`)
    }
    : null;

  const page = data.page_content;
  const sections = page.sections || [];
  if (!sections.length) return null;

  return (
    <>
      {banner && banner.images && banner.images.length > 0 && (
        <DynamicBanner title={banner.title || ""} bgImage={banner.images}  bgImageMobile={banner.mobileimage}/>
      )}

      <section className="examination-page pb_80">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{page.main_heading || banner?.title || ""}</h2>
          </div>

          <ul className="nav nav-tabs main-tab-exam d-flex justify-content-center align-items-center" id="examinationTabs" role="tablist">
            {sections.map((sec, idx) => (
              <li className="nav-item" role="presentation" key={idx}>
                <button
                  className={`nav-link ${idx === activeIndex ? "active" : ""}`}
                  id={`${sec.sections_heading?.toLowerCase().replace(/\s+/g, "-")}-tab`}
                  data-bs-toggle="tab"
                  data-bs-target={`#tab-${idx}`}
                  type="button"
                  role="tab"
                  aria-selected={idx === activeIndex}
                  aria-controls={`tab-${idx}`}
                  onClick={() => setActiveIndex(idx)}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowRight") setActiveIndex((i) => (i + 1) % sections.length);
                    if (e.key === "ArrowLeft") setActiveIndex((i) => (i - 1 + sections.length) % sections.length);
                  }}
                >
                  {sec.sections_heading}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content" id="examinationTabssContent">
            {sections.map((sec, sidx) => (
              <div
                key={sidx}
                className={`tab-pane fade ${sidx === activeIndex ? "active show" : ""} mt-3`}
                id={`tab-${sidx}`}
                role="tabpanel"
                aria-labelledby={`${sec.sections_heading?.toLowerCase().replace(/\s+/g, "-")}-tab`}
              >

                {Array.isArray(sec.items) &&
                  sec.items.map((item, idx) => {

                    const hasImage = !!item.image;

                    return (
                      <div
                        className={`row mt-3 ${hasImage ? "d-flex align-items-center" : ""}`}
                        key={idx}
                      >

                        {/* LEFT IMAGE */}
                        {item.image && item.position === "left" && (
                          <div className="col-lg-5 col-12">
                            <img src={item.image} className="img-fluid rounded shadow-sm w-100 mb-2 mb-md-0" />
                          </div>
                        )}

                        {/* CONTENT */}
                        <div className={hasImage ? "col-lg-7 col-12" : "col-12"}>
                          {item.heading && <h4 className="mb-3">{item.heading}</h4>}
                          {item.content && (
                            <div dangerouslySetInnerHTML={{ __html: item.content }} />
                          )}
                        </div>

                        {/* RIGHT IMAGE */}
                        {item.image && item.position === "right" && (
                          <div className="col-lg-5 col-12">
                            <img src={item.image} className="img-fluid rounded shadow-sm w-100 mb-2 mb-md-0" />
                          </div>
                        )}

                      </div>
                    );
                  })
                }

              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Examination;
